import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'default-button',
  props: {
  color: {
    type: String,
    default: "white",
  },
},
  setup(__props) {

const props = __props;
const color = computed(() => {
  return props.color;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'border-green text-green hover:bg-green hover:text-white':
        color.value === 'green',
      'border-white text-white hover:bg-white hover:text-black':
        color.value !== 'green',
    }, "border px-5 py-2 cursor-pointer transition-all text-center"])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})